/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "../../../components/MKBox";

// Images
import ota from "assets/images/emtay/ota_logo.png";
import ltp from "assets/images/emtay/ltp_logo.png";
import cf from "assets/images/emtay/cf_logo.png";
import emesa from "assets/images/emtay/emesa_logo.png";
import MKTypography from "../../../components/MKTypography";

// i18n
import { useLanguage } from "i18n";

function Testimonials() {
  const { t } = useLanguage();

  return (
    <MKBox component="section" pt={3} pb={8} py={2}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={8}
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          sx={{ mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h4" my={1}>
            {t("testimonials.title")}
          </MKTypography>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={6} md={3} lg={3}>
            <MKBox component="img" src={ota} alt="On That Ass" width="100%" opacity={0.7} />
          </Grid>
          <Grid item xs={6} md={3} lg={3}>
            <MKBox component="img" src={ltp} alt="LTP" width="100%" opacity={0.7} />
          </Grid>
          <Grid item xs={6} md={3} lg={3}>
            <MKBox component="img" src={cf} alt="Creative Fabrica" width="100%" opacity={0.7} />
          </Grid>
          <Grid item xs={6} md={3} lg={3}>
            <MKBox component="img" src={emesa} alt="Emesa" width="100%" opacity={0.7} />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Testimonials;
